import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { getWorkSingle } from "../api";
import { useEffect, useRef, useState } from "react";
import DetailView from "../components/ContentDetail/DetailView";

export default function WorkDetail() {
  const { workId } = useParams();
  const nav = useNavigate();

  const workQuery = useQuery({
    queryKey: ["work", workId],
    queryFn: getWorkSingle,
  });
  const [contentType, setContentType] = useState<"Content" | "Video" | "Slide">(
    "Content"
  );
  useEffect(() => {
    if (workQuery.data?.content_type.includes("video")) {
      setContentType("Video");
    } else if (workQuery.data?.content_type.includes("slide")) {
      setContentType("Slide");
    } else {
      setContentType("Content");
    }
  }, [workQuery.data?.content_type]);

  return <DetailView data={workQuery.data} />;
}
